__turbopack_context__.v({
  "label": "NavLink-module__F-YP8q__label",
  "root": "NavLink-module__F-YP8q__root",
});
